// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 761 ? "d0deef33" : chunkId) + "." + {"203":"2940f5bb202fd09d","218":"f971a05ca712a2ef","761":"4e8070dbb5b25eac","961":"b8eb82058d43fa99"}[chunkId] + ".js";
};